export default __webpack_public_path__ + "static/media/secondOptionNDA.png?.83ab5891";